class MicrositeNav {
  constructor() {
    if (!document.body.classList || !document.body.classList.contains("microsite")) {
      return
    }

    this.nav = document.getElementById("ms-primary-nav")
    this.mobileBtn = document.getElementById("ms-open-menu")
    this.currentActive = null
    this.init()
  }

  init() {
    window.addEventListener("mousedown", this.mousedownHandler.bind(this))
    window.addEventListener("resize", this.resizeHandler.bind(this))
    this.nav.querySelectorAll(".submenu-toggler").forEach(toggler => {
      toggler.addEventListener("click", this.clickHandler.bind(this))
    })
    this.mobileBtn.addEventListener("click", this.mobileMenuHandler.bind(this))
    window.dispatchEvent(new Event("resize"))
  }

  resizeHandler() {
    this.closeActive()
    this.closeMobileMenu()
  }

  closeMobileMenu() {
    if (document.body.offsetWidth < 992) {
      this.nav.setAttribute("aria-labelledby", "ms-open-menu")
      this.nav.ariaHidden = "true"
    } else {
      this.nav.removeAttribute("aria-labelledby")
      this.nav.removeAttribute("aria-hidden")
    }

    const icon = this.mobileBtn.querySelector("i")

    icon.classList.remove("icon-close-menu")
    icon.classList.add("icon-open-menu")
    this.nav.classList.remove("d-block")
    this.mobileBtn.ariaExpanded = "false"
    this.mobileBtn.ariaLabel =
      this.mobileBtn.ariaLabel.indexOf("Open ") == 0
        ? this.mobileBtn.ariaLabel
        : this.mobileBtn.ariaLabel.replace("Close ", "Open ")

    this.closeActive()
    this.removeOverlay()
  }

  /**
   * Add main menu overlay
   */
  addOverlay() {
    let overlay = document.querySelector(".site-header__mobile-menu-overlay")

    if (!overlay) {
      const body = document.querySelector("body")

      overlay = document.createElement("div")
      overlay.classList.add("site-header__mobile-menu-overlay")
      body.append(overlay)
    }
  }

  /**
   * Remove main menu overlay
   */
  removeOverlay() {
    const overlay = document.querySelector(".site-header__mobile-menu-overlay")
    if (overlay) {
      overlay.remove()
    }
  }

  mobileMenuHandler(e) {
    e.preventDefault()
    const icon = this.mobileBtn.querySelector("i")

    if (icon.classList.contains("icon-close-menu")) {
      icon.classList.remove("icon-close-menu")
      icon.classList.add("icon-open-menu")
      this.removeOverlay()
    } else {
      icon.classList.remove("icon-open-menu")
      icon.classList.add("icon-close-menu")
      this.addOverlay()
    }

    this.nav.classList.toggle("d-block")
    this.mobileBtn.ariaExpanded = this.mobileBtn.ariaExpanded == "true" ? "false" : "true"
    this.mobileBtn.ariaLabel =
      this.mobileBtn.ariaLabel.indexOf("Open ") == 0
        ? this.mobileBtn.ariaLabel.replace("Open ", "Close ")
        : this.mobileBtn.ariaLabel.replace("Close ", "Open ")
    this.closeActive()
  }

  clickHandler(e) {
    e.preventDefault()
    const btn = e.currentTarget

    if (this.currentActive && this.currentActive.id != btn.id) {
      this.closeActive()
    }

    const menu = document.getElementById(btn.getAttribute("aria-controls"))
    this.currentActive = btn
    btn.ariaExpanded = btn.ariaExpanded == "true" ? "false" : "true"
    menu.ariaHidden = menu.ariaHidden == "true" ? "false" : "true"
    btn.ariaLabel =
      btn.ariaLabel.indexOf("Open ") == 0
        ? btn.ariaLabel.replace("Open ", "Close ")
        : btn.ariaLabel.replace("Close ", "Open ")

    if (menu.ariaHidden == "false") {
      menu.classList.remove("right-aligned")

      if (this.getLeftOffset(menu) + menu.offsetWidth > document.body.offsetWidth) {
        menu.classList.add("right-aligned")
      }
    }
  }

  getLeftOffset(el) {
    const box = el.getBoundingClientRect()

    const body = document.body
    const docEl = document.documentElement

    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

    const clientLeft = docEl.clientLeft || body.clientLeft || 0

    const left = box.left + scrollLeft - clientLeft

    return Math.round(left)
  }

  closeActive() {
    if (!this.currentActive) {
      return
    }

    const menu = document.getElementById(this.currentActive.getAttribute("aria-controls"))
    this.currentActive.ariaExpanded = "false"
    menu.ariaHidden = "true"
    this.currentActive.ariaLabel =
      this.currentActive.ariaLabel.indexOf("Open ") == 0
        ? this.currentActive.ariaLabel.replace("Open ", "Close ")
        : this.currentActive.ariaLabel

    this.currentActive = null
  }

  mousedownHandler(e) {
    const shallStay =
      (e.target.classList && e.target.classList.contains("ms-main-nav__list__submenu")) ||
      e.target.closest(".ms-main-nav__list__submenu") ||
      (e.target.classList && e.target.classList.contains("submenu-toggler")) ||
      e.target.closest(".submenu-toggler") ||
      e.target.id == "ms-open-menu" ||
      e.target.closest("#ms-open-menu") ||
      e.target.closest(".ms-main-nav__list")
        ? true
        : false

    if (!shallStay) {
      this.closeMobileMenu()
    }
  }
}

export default MicrositeNav
